export default __webpack_public_path__ + "static/media/suns_black.d7ce230b.png";